<div class="modal__header">
	<div class="title_wrapper">
		<h2 class="title" id="modal__title">New contact</h2>
	</div>
	<div class="modal__header-actions header-actions">
		<button aria-label="Close dialog" (click)="closeModal()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body">
	<form [formGroup]="contactForm">
		<div class="form-field--row grid no-padding">
			<div class="form-field col-6 col-tp-6 col-p-12 no-margin-adjustment">
				<label class="label" for="name-contact">Name</label>
				<input placeholder="Insert contact name" inputmode="text" class="input-text" formControlName="name" name="name"
					id="name-contact" [ngClass]="TAP_hasErrors('name')" />
			</div>

			<div class="form-field col-6 col-tp-6 col-p-12 no-margin-adjustment">
				<label class="label" for="email-adress-contact">Email adress contact</label>
				<input placeholder="Insert contact email" inputmode="email" class="input-text" formControlName="email"
					name="email" id="email-adress-contact" [ngClass]="TAP_hasErrors('email')" />
				<span aria-live="polite" class="input-error" role="alert" *ngIf="TAP_formInvalid('email')">{{
					TAP_formErrors('email') }}</span>
			</div>
		</div>
		<div class="form-field--row grid no-padding">
			<div class="col-12">
				<label class="label" for="phone_number">Phone Number</label>
			</div>
			<div class="form-field col-6 col-tp-6 col-p-12">
				<app-select-input [parentForm]="contactForm" formControlName="phone_prefix" [id]="'phone_prefix'"
					[required]="true" [errorMessage]="'This field is required'" [placeholder]="'Select country code'"
					[inputOptions]="dialCodes">
				</app-select-input>
				<span aria-live="polite" class="input-error" role="alert" *ngIf="TAP_formInvalid('phone_prefix') ">{{
					TAP_formErrors('phone_prefix') }}</span>
			</div>

			<div class="form-field col-6 col-tp-6 col-p-12">
				<input inputmode="tel" id="phone_number"
					class="input-text select {{ TAP_formInvalid('phone_number') }}" placeholder="Insert phone number"
					aria-label="enter phone number" aria-describedby="phone_number-error"
					formControlName="phone_number" />
				<span aria-live="polite" class="input-error" id="phone_number-error" role="alert"
					*ngIf="TAP_formInvalid('phone_number') ">{{ TAP_formErrors('phone_number') }}</span>
			</div>
		</div>
	</form>
</div>
<div class="modal__footer">
	<div class="modal__footer-action">
		<button class="button button--small button-main-line" (click)="TAP_handleCancel()">Cancel</button>
		<button class="button button--small" (click)="TAP_handleConfirm()">Confirm new contact</button>
	</div>
</div>
